import {
  getCategories,
  getLoggedOutTemplates,
  getProducts,
} from "src/lib/actions";
import {
  LibraryTemplate,
  MetaProduct,
  NavigationLink,
} from "src/server/zsl/templates/types";

export type ServiceRoute = {
  text: string;
  href?: string;
  onClick?: () => void;
};

//////////////////////////////////////////////////////////////////////////////
// ToSlug utils //////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////////////////

export const navigationLinkToSlug = (c: NavigationLink): string => c.slug;

export const templateToSlug = (t: LibraryTemplate): string => t.meta.slug;

//////////////////////////////////////////////////////////////////////////////
// ToPath utils //////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////////////////

export const serviceRootPath = `/templates`;

//////////////////////////////////////////////////////////////////////////////
// ToRoute utils /////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////////////////

export const serviceRootRoute: ServiceRoute = {
  text: "Templates",
  href: serviceRootPath,
};

export const buildNavigationRoute = (
  navigationObject: NavigationLink,
  pathname: string | null,
  queryParamName?: "category" | "app",
): ServiceRoute => {
  if (!pathname) {
    return {
      text: navigationObject.name,
      href: `templates`,
    };
  }

  if (queryParamName) {
    return {
      text: navigationObject.name,
      href: `${pathname}?${queryParamName}=${navigationLinkToSlug(navigationObject)}`,
    };
  }
  const path = `${serviceRootPath}/${navigationLinkToSlug(navigationObject)}`;
  return { text: navigationObject.name, href: path };
};

export const productToRoute = async (
  productSlug: MetaProduct,
): Promise<ServiceRoute> => {
  const products = await getProducts();
  const product = products?.find((p) => p.slug === productSlug);
  const path = `${serviceRootPath}/${product?.slug}`;
  return { text: product?.displayName ?? "", href: path };
};

//////////////////////////////////////////////////////////////////////////////
// getStaticPaths utils //////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////////////////

export type ParamWithSlug = { slug: string };

export async function getStaticPathsAsParamsWithSlugs(): Promise<
  ParamWithSlug[]
> {
  const categories = await getCategories({ draftMode: false });
  const products = await getProducts();

  const categoryParams =
    categories?.map((c) => ({
      slug: c.slug ?? "",
    })) ?? [];
  const productParams =
    products?.map((p) => ({
      slug: p?.slug ?? "",
    })) ?? [];

  return [...categoryParams, ...productParams];
}

export async function getStaticPathsAsParamsWithTemplateSlugs(): Promise<
  ParamWithSlug[]
> {
  const templates = await getLoggedOutTemplates({ draftMode: false });
  const templateParams =
    templates?.map((t) => ({
      slug: t.slug,
    })) ?? [];

  return templateParams;
}
